
import { Search, Calendar, Video, Star } from 'lucide-react';
import { cn } from '@/lib/utils';
import { T } from '@/components/T';

const HowItWorksSection = () => {
  const steps = [
    {
      number: 1,
      icon: <Search className="h-6 w-6" />,
      title: "Find Your Therapist",
      description: "Search By Location Specialty",
      color: "bg-blue-400",
    },
    {
      number: 2,
      icon: <Calendar className="h-6 w-6" />,
      title: "Book Your Session",
      description: "Select Convenient Time",
      color: "bg-blue-500",
    },
    {
      number: 3,
      icon: <Video className="h-6 w-6" />,
      title: "Connect Securely",
      description: "Join Session Securely",
      color: "bg-blue-600",
    },
    {
      number: 4,
      icon: <Star className="h-6 w-6" />,
      title: "Continue Your Journey",
      description: "Schedule Follow Up Sessions",
      color: "bg-blue-700",
    },
  ];

  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            <T>How It Works</T>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
            <T>How It Works Description</T>
          </p>
        </div>
        
        <div className="relative">
          {/* Connector Line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-slate-200 -translate-y-1/2 z-0"></div>
          
          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className="relative animate-fade-in-up"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                {/* Step Number/Icon */}
                <div className="flex justify-center mb-6 relative z-10">
                  <div className={cn(
                    "flex items-center justify-center w-16 h-16 rounded-full text-white",
                    step.color
                  )}>
                    <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-white border-2 border-slate-200 flex items-center justify-center text-slate-800 font-bold">
                      {step.number}
                    </div>
                    {step.icon}
                  </div>
                </div>
                
                {/* Content */}
                <div className="text-center px-4">
                  <h3 className="text-xl font-semibold text-slate-900 mb-3">
                    <T>{step.title}</T>
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    <T>{step.description}</T>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
